import { useLocalStorage } from "../components/useLocalStorage";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { Outlet, Link } from "react-router-dom";

import { useState } from "react";

const TextFieldStyle = { width: '100%' };

const AppBoardScreen = () => {

    const [EmailPersonal, setEmailPersonal] = useLocalStorage("EmailPersonal", "");
    const [buttonStatus, setButtonStatus] = useState(false);  
    const inputChangeHandler = () => {
        setTimeout(() => {
            if (EmailPersonal.length > 0 ) {
                setButtonStatus(true);
            } else {
                setButtonStatus(false);
            }    
        }, 100)
    };

    inputChangeHandler();

    return (
        <Box id="AppBoardScreen1" className="AppBoardScreen AppBoardScreen1" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/ElectronicReceiptShippingUpdates">
                        <Button variant="outlined" size="large">Regresar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">¿Cuál es tu correo electrónico?</h2>
                </Grid>
                <Grid item xs={12}>
                    <TextField onKeyUp={inputChangeHandler} onChange={(e) => setEmailPersonal(e.target.value)} value= {EmailPersonal} label="Email personal" variant="outlined" sx={TextFieldStyle} />
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/cambio/CurrentlyYourProcessRequirePerformingSmog">
                        <Button disabled={!buttonStatus} className="ContinueButton" variant="contained" color="success" size="large" sx={{ width: "50%" }}>Continuar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/cambio/YourRegistrationCurrentlySuspended">
                        <Button disabled={!buttonStatus} className="ContinueButton" variant="contained" color="success" size="large" sx={{ width: "50%" }}>Test</Button>
                    </Link>
                </Grid>

                <Outlet/>
            </Grid>
        </Box>
    );
};

export default AppBoardScreen;